<template>
  <div>
    <HeraFormDropdown
      key="best-of-final-field"
      v-model="bestOfFinal"
      v-validate="'required'"
      :view-mode="disabled"
      :disabled="isStageFieldDisabled('bestOfFinal') || disabled"
      name="bestOfFinal"
      :label="$$t('Best of (final):', 'best-of-final_label')"
      :list="bestOfList"
      :class="{ 'is-invalid': errors.first('bestOfFinal') }"
      variant="input-like"
      required
      :error="errors.first('bestOfFinal')"
      :empty-text="$$t('Choose option', 'best-of-final-placeholder')"
      :tooltip="
        $$t(
          'How many games within one final match must be played',
          'best-of-final-tooltip'
        )
      "
      show-label
      empty-option
    >
      <template slot="chosen" slot-scope="chosen">
        {{ chosen.chosenItem }}
      </template>

      <template slot="item" slot-scope="{ item }">
        {{ item }}
      </template>
    </HeraFormDropdown>
  </div>
</template>

<script>
import { translate } from '@/mixins/translate';
import HeraFormDropdown from '@/components/molecules/form/HeraFormDropdown';
import stageSetupHelpers from '@/views/tournaments/management/singleTournament/mixins/stageHelpers';
import { prop } from '@/utils/factories';
export default {
  name: 'StageBestOfFinalSetting',
  components: {
    HeraFormDropdown,
  },
  inject: ['$validator'],
  mixins: [translate('_web_tournament_stage-editor'), stageSetupHelpers],
  props: {
    disabled: prop(Boolean),
  },
  computed: {
    bestOfFinal: {
      get() {
        return this.getBlockConfigurationByKey('best_of_final');
      },
      set(newVal) {
        this.setBlockConfigurationByKey('best_of_final', +newVal);
      },
    },
    bestOfLabel() {
      return this.isDoubleElimination
        ? this.$$t('Best of (Upper):', 'best-of-upper_label')
        : this.$$t('Best of:', 'best-of_label');
    },
    bestOfList() {
      return this.stageDefaults[this.tieMatchAllowed ? 'bestOfTie' : 'bestOf'];
    },
  },
};
</script>

<style></style>
